import ViewHub from './ViewHub'

export default ViewHub
